function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP FAQ component for home page
 * 
 */
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './Faq.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Faq extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggle", () => {
      this.setState({
        show: !this.state.show
      });
    });
    this.state = {
      show: false
    };
  }
  render() {
    const {
      title,
      content
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "Faq",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "toggle",
        onClick: this.toggle,
        children: [!this.state.show && /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faChevronDown
        }), this.state.show && /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faChevronUp
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "content",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "line question",
          onClick: this.toggle,
          children: [/*#__PURE__*/_jsx("div", {
            className: "prefix",
            children: "Q"
          }), /*#__PURE__*/_jsx("div", {
            className: "title md",
            children: title
          })]
        }), this.state.show && /*#__PURE__*/_jsxs("div", {
          className: "line answer",
          children: [/*#__PURE__*/_jsx("div", {
            className: "prefix",
            children: "A"
          }), /*#__PURE__*/_jsx("div", {
            dangerouslySetInnerHTML: {
              __html: content
            }
          })]
        })]
      })]
    });
  }
}
_defineProperty(Faq, "defaultProps", {
  number: null,
  title: 'Succinct title',
  content: '<p>This is some HTML content</p>'
});
export default Faq;